import { render, staticRenderFns } from "./PDPTldr.vue?vue&type=template&id=74a49bb4&scoped=true&"
import script from "./PDPTldr.vue?vue&type=script&lang=js&"
export * from "./PDPTldr.vue?vue&type=script&lang=js&"
import style0 from "./PDPTldr.vue?vue&type=style&index=0&id=74a49bb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a49bb4",
  null
  
)

export default component.exports